<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2022-03-11 14:30:38
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-01-25 14:20:04
 * @FilePath: /wemeet-iam/Users/hvv/weMeetSpace/WeMeet_admin_project/wemeet-admin/src/views/dragger/template/tpl-title.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->

<template>
  <div class="layout">
    <div class="background">
      <div class="title" :style="{ color: res.list[0].color }">
        {{ res.list[0].title }}
      </div>
    </div>
  </div>
</template>

<script>
  import { defineAsyncComponent, defineComponent, getCurrentInstance, onMounted, reactive, toRefs, watch } from 'vue'
  export default defineComponent({
    name: 'TplTitle',
    props: {
      res: Object,
    },
    setup(props, { emit }) {
      const { proxy } = getCurrentInstance

      const state = reactive({
        nowItem: {},
        fit: 'fill',
      })
      onMounted(() => {})
      watch(
        () => props.res,
        (newVal, oldVal) => {},
        { deep: true }
      )

      return {
        ...toRefs(state),
      }
    },
  })
</script>
<style lang="scss" scoped>
  @import './tpl.scss';
  .background {
    position: absolute;
    z-index: 2;
    width: 100%;

    height: 42px;
    background: url('https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/MEHZ/images/title.png') no-repeat;
    background-size: cover;
  }
  .layout {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 42px;
    text-align: left;

    background: #ffffff;
  }
  .title {
    font-size: 16px;
    font-weight: bold;
    line-height: 42px;
    color: #262626;
    padding: 0 20px;
    position: relative;
    &::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 10px;
      transform: translateY(-50%);
      width: 3px;
      height: 17px;
      background: #3079fe;
    }
  }
</style>
